import { captureSentryError, useGqtyClient, useTeam } from '@vrplatform/data';
import { showLoadingNotification } from '@vrplatform/theme';
import {
  showWarnNotification,
  updateErrorNotification,
  updateSuccessNotification,
} from '@vrplatform/theme';
import {
  type StatementSummaryUnion,
  ownerStatementCsvQuery,
} from '@vrplatform/ui-common';
import { useId, useState } from 'react';
import { downloadFromUrl, getCsvUrl } from '../../../../utils';

export const useStatementCsvExport = () => {
  const [loading, setLoading] = useState(false);
  const notifyId = useId();
  const client = useGqtyClient();
  const [{ id: teamId }] = useTeam();

  const download = async (args: {
    statementIds: string[];
    groupedBy: StatementSummaryUnion;
    ownerId: string | undefined;
  }) => {
    if (!args.statementIds.length) {
      showWarnNotification({ message: 'No statements selected' });
      return;
    }

    try {
      setLoading(true);
      showLoadingNotification({ id: notifyId });

      const { rows, listingName } = await ownerStatementCsvQuery(client, {
        ...args,
        teamId,
      });

      updateSuccessNotification({
        id: notifyId,
        title: 'CSV Download',
        message: 'CSV was successfully downloaded.',
      });

      const getCsvName = () => {
        if (args.statementIds.length > 1) return 'owner-statement-summary';
        return listingName || 'owner-statement';
      };

      const url = getCsvUrl(rows);
      downloadFromUrl(url, getCsvName());
    } catch (error: any) {
      console.error(error);
      captureSentryError(error);
      updateErrorNotification({
        id: notifyId,
        title: 'CSV Download',
        message: 'An error occurred while downloading CSV.',
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    downloadCsv: download,
    loading,
  };
};
